import { LegalShell } from "./LegalShell";

export default function Shipping() {
  return (
    <LegalShell
      title="Shipping Policy"
      subtitle="How we get your dress to you, fast, safe, and beautifully packaged."
      path="/shipping"
      updated="February 12, 2026"
      sections={[
        {
          id: "where-we-ship",
          heading: "Where we ship",
          body: (
            <p>Everywhere in the United States. We are Wisconsin-first — customers in-state get faster
            fulfillment, and Milwaukee-metro orders placed before noon usually ship the same day.</p>
          ),
        },
        {
          id: "rates",
          heading: "Rates & free shipping",
          body: (
            <>
              <p><b>Standard shipping (3–7 business days):</b> flat $9.99 per order.</p>
              <p><b>Expedited (2–3 business days):</b> $19.99.</p>
              <p><b>Free standard shipping</b> on any order over $150 (including tux bundles).</p>
            </>
          ),
        },
        {
          id: "processing",
          heading: "Processing time",
          body: (
            <>
              <p>Most orders are packed and shipped within <b>1–2 business days</b> of purchase. During peak
              prom season (March–May) processing can extend to 3 business days.</p>
              <p>Bespoke and altered pieces have their own timelines — you'll see the exact estimate on the
              product page and again in your order confirmation.</p>
            </>
          ),
        },
        {
          id: "tracking",
          heading: "Tracking",
          body: (
            <p>Every order gets a tracking link the moment we hand it to the carrier — emailed to you and
            visible in your account under "Orders." If you don't see one within 3 business days, email
            <a className="text-rosemetal" href="mailto:support@heathersboutique.com"> support@heathersboutique.com</a>.</p>
          ),
        },
        {
          id: "packaging",
          heading: "How your dress arrives",
          body: (
            <>
              <p>Every dress ships hung in a Heather's Boutique branded garment bag inside a rigid shipping
              carton, wrapped in tissue with a handwritten thank-you card. Add luxury gift wrap ($12) at
              checkout for silk ribbon and a personal note card.</p>
            </>
          ),
        },
        {
          id: "prom-season",
          heading: "Prom-week rush shipping",
          body: (
            <>
              <p>Ordered close to your prom date? We offer overnight shipping ($34.99) for orders placed at
              least 3 days before your event, and we hand-deliver locally within a 30-mile radius of
              Oconomowoc for $50 (call the store to arrange).</p>
              <p>If you're within a week of your prom, call before you order — Heather will personally make
              sure it gets there on time.</p>
            </>
          ),
        },
        {
          id: "issues",
          heading: "Late or lost packages",
          body: (
            <p>If your package is marked delivered but you can't find it, please check with neighbors and
            your local post office first, then contact us within 5 business days. We'll open a carrier claim
            and, for insured shipments, send a replacement while it's being investigated.</p>
          ),
        },
        {
          id: "international",
          heading: "International orders",
          body: (
            <p>We do not currently ship internationally. If you're outside the US and want a specific dress,
            email us — we occasionally arrange white-glove international shipping for grail pieces.</p>
          ),
        },
      ]}
    />
  );
}
